import React, { useEffect, useState } from 'react';

import NavBar from '../components/nav/Nav';
import Footer from '../components/footer/Footer';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const Contacto = () => {
    
    const [animationNav, setAnimationNav] = useState('move');
    const [animationFooter, setAnimationFooter] = useState(null);
    const [animationContent, setAnimationContent] = useState('fade');
    const [submitedMail, setSubmitedMail] = useState(false);

    const handleNavButtonClick = async () => {
        setAnimationContent('fade-away');
        await new Promise(resolve => setTimeout(resolve, (300)));
        setAnimationFooter('away-move');
        await new Promise(resolve => setTimeout(resolve, (100)));
        setAnimationNav('move-away');
        await new Promise(resolve => setTimeout(resolve, (300)));
        window.scrollTo(0, 0);
    };

    const handleFooterButtonClick = async () => {
        setAnimationContent('fade-away')
        await new Promise(resolve => setTimeout(resolve, (300)));
        setAnimationNav('move-away');
        await new Promise(resolve => setTimeout(resolve, (100)));
        setAnimationFooter('away-move');
        await new Promise(resolve => setTimeout(resolve, (300)));
        window.scrollTo(0, 0);
    };

    const [opa, setOpa] = useState(0);
    const [isNavHidden, setIsNavHidden] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setOpa(opa + 0.1);
            if (prevScrollPos > currentScrollPos) {
                if (isNavHidden || window.scrollY < 1) {
                    navBar.style.transform = 'translateY(0)';
                    setIsNavHidden(false);
                }
            } else {
                if (!isNavHidden && window.innerWidth > 800 && window.scrollY > 1) {
                    navBar.style.transform = 'translateY(-100%)';
                    setIsNavHidden(true);
                }
            }
            setPrevScrollPos(currentScrollPos);
        };

        const navBar = document.querySelector('nav');
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isNavHidden, prevScrollPos,]);

    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        empresa: '',
        telefono: '',
        mensaje: '',
    });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.send("service_h09swtt","template_voifeom", {
            nombre: formData.nombre,
            email: formData.email,
            empresa: formData.empresa,
            telefono: formData.telefono,
            mensaje: formData.mensaje,
        }, "zDpiUKqzrgFWfzwQl");
        setSubmitedMail(true);
    }

    return (
        <div id="flotas" className="w-full">
            <nav className={`${animationNav} w-full b-black`}>
                <NavBar actual={5} onNavButtonClick={handleNavButtonClick} />
            </nav>
            <div id="contacto-content" className={`${animationContent} w-full flex flex-col items-center`}>
                <Link id="whatsapp-fixed" target="_blank" to="https://wa.me/541133573254" style={{ opacity: opa }}>
                    <svg viewBox="0 0 48 48">
                        <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"></path><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"></path><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"></path><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"></path><path fill="#fff" fill-rule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clip-rule="evenodd"></path>
                    </svg>
                </Link>
                <div id="contacto-banner" className="w-full banner-1 flex justify-center flex-col">
                    <h2 id="contacto-banner-title" className="w-1/3 fade-delay-1 c-white poppins-600 ms-36">CONTACTO</h2>
                    <h3 id="contacto-banner-subtitle" className="w-1/3 fade-delay-1-5 c-white poppins-400 ms-36">Comunicate con nosotros</h3>
                </div>
                <div id="contacto-form-section" className="w-full flex justify-center">
                    <div id="contacto-form-intro" className="w-1/3 flex flex-col poppins-500">
                        <h5 className="mb-6 fade-delay-right-3">Para contactarte con nosotros, podés llenar este formulario o escribirnos directamente por Whatsapp o Mail.</h5>
                        <div id="contacto-form-intro-datos" className="flex flex-col fade-delay-right-3-5">
                            <div className="flex items-center flex-nowrap">
                                <svg viewBox="0,0,256,256">
                                    <g fill="#dc2626"><g transform="scale(5.12,5.12)"><path d="M25,2c-12.682,0 -23,10.318 -23,23c0,3.96 1.023,7.854 2.963,11.29l-2.926,10.44c-0.096,0.343 -0.003,0.711 0.245,0.966c0.191,0.197 0.451,0.304 0.718,0.304c0.08,0 0.161,-0.01 0.24,-0.029l10.896,-2.699c3.327,1.786 7.074,2.728 10.864,2.728c12.682,0 23,-10.318 23,-23c0,-12.682 -10.318,-23 -23,-23zM36.57,33.116c-0.492,1.362 -2.852,2.605 -3.986,2.772c-1.018,0.149 -2.306,0.213 -3.72,-0.231c-0.857,-0.27 -1.957,-0.628 -3.366,-1.229c-5.923,-2.526 -9.791,-8.415 -10.087,-8.804c-0.295,-0.389 -2.411,-3.161 -2.411,-6.03c0,-2.869 1.525,-4.28 2.067,-4.864c0.542,-0.584 1.181,-0.73 1.575,-0.73c0.394,0 0.787,0.005 1.132,0.021c0.363,0.018 0.85,-0.137 1.329,1.001c0.492,1.168 1.673,4.037 1.819,4.33c0.148,0.292 0.246,0.633 0.05,1.022c-0.196,0.389 -0.294,0.632 -0.59,0.973c-0.296,0.341 -0.62,0.76 -0.886,1.022c-0.296,0.291 -0.603,0.606 -0.259,1.19c0.344,0.584 1.529,2.493 3.285,4.039c2.255,1.986 4.158,2.602 4.748,2.894c0.59,0.292 0.935,0.243 1.279,-0.146c0.344,-0.39 1.476,-1.703 1.869,-2.286c0.393,-0.583 0.787,-0.487 1.329,-0.292c0.542,0.194 3.445,1.604 4.035,1.896c0.59,0.292 0.984,0.438 1.132,0.681c0.148,0.242 0.148,1.41 -0.344,2.771z"></path></g></g>
                                </svg>
                                <p className="text-red-600 poppins-600 ms-1 text-nowrap">(+54) 0 11 3357-3254</p>
                            </div>
                            <div className="flex items-center flex-nowrap">
                                <svg fill="#dc2626" viewBox="0 0 24 24">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                                    <g id="SVGRepo_iconCarrier">
                                        <path d="M22,5V9L12,13,2,9V5A1,1,0,0,1,3,4H21A1,1,0,0,1,22,5ZM2,11.154V19a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V11.154l-10,4Z"/>
                                    </g>
                                </svg>
                                <p className="text-red-600 poppins-600 ms-1 ps-0.5 text-nowrap">info@nrtallerintegral.com.ar</p>
                            </div>
                        </div>
                    </div>
                    <div id="contacto-form-container" className="w-2/3 bg-red-600 fade-delay-right-4-2">
                        <form id="contacto-form" className="w-full h-full bg-neutral-200 flex flex-col inter-400 p-2" onSubmit={handleSubmit}>
                            <div className="flex w-full p-1 gap-2">
                                <div className="w-1/2 p-1">
                                    <input
                                        className="w-full py-1 px-2"
                                        type="text"
                                        name="nombre"
                                        placeholder="Nombre"
                                        value={formData.nombre}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-1/2 p-1">
                                    <input
                                        className="w-full py-1 px-2"
                                        type="email"
                                        name="email"
                                        placeholder="Mail"
                                        value={formData.mail}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="flex w-full p-1 gap-2">
                                <div className="w-1/2 p-1">
                                    <input
                                        className="w-full py-1 px-2"
                                        type="text"
                                        name="empresa"
                                        placeholder="Empresa"
                                        value={formData.empresa}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-1/2 p-1">
                                    <input
                                        className="w-full py-1 px-2"
                                        type="tel"
                                        name="telefono"
                                        placeholder="Teléfono"
                                        value={formData.telefono}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="w-full p-2">
                                <textarea
                                    className="w-full py-1 px-2"
                                    name="mensaje"
                                    placeholder="Mensaje"
                                    value={formData.mensaje}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="w-full flex items-center justify-center">
                                {!submitedMail ?
                                    <button type="submit" className="w-fit josefin-700 text-red-600 mb-1 transition ease-in-out duration-300 hover:text-red-500">ENVIAR</button>
                                    :
                                    <div className="josefin-700 text-red-600">MENSAJE ENVIADO</div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
                <div id="contacto-section-2-container" className="w-full flex justify-center fade-delay-right-4-5">
                    <div id="contacto-section-2" className="w-full flex items-end">
                        <iframe id="contacto-mapa" className="w-3/5" title="mapa" src="https://www.google.com/maps/embed/v1/place?q=NR+Taller+Integral,+Luzuriaga,+Hurlingham,+Buenos+Aires+Province,+Argentina&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&zoom=14" />
                        <div id="contacto-encontranos" className="flex flex-col w-2/5">
                            <h3 className="poppins-400 dn-3">ENCONTRANOS EN</h3>
                            <svg fill="#dc2626" className="dn-4 h-5 w-5 trasnform translate-y-1" viewBox="0 0 395.71 395.71" stroke="#dc2626">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                                <g id="SVGRepo_iconCarrier"> <g> <path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738 c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388 C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191 c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z"/> </g> </g>
                            </svg>
                            <h3 className="poppins-600 text-red-600">LUZURIAGA 757, HURLINGHAM</h3>
                        </div>
                    </div>
                </div>
            </div>
            <footer className={`${animationFooter} w-full`}>
                <Footer actual={5} onFooterButtonClick={handleFooterButtonClick} />
            </footer>
        </div>
    );
}

export default Contacto;
